export default __webpack_public_path__ + "static/media/a004-b.07462c08.jpg";